module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Images Annotator")]), _c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Label your images, get a summary spreadsheet")]), _c('label', {
    staticClass: "btn btn-default btn-file center-block",
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v("Select some pictures"), _c('input', {
    staticClass: "hidden file",
    attrs: {
      "type": "file",
      "multiple": "1",
      "name": "files"
    },
    on: {
      "change": _vm.changeImages
    }
  })]), (_vm.images.length) ? _c('div', {
    staticClass: "diaporama"
  }, [_vm._l((_vm.images), function(image, i) {
    return (i === _vm.index) ? _c('div', {
      key: i
    }, [_c('h4', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(i + 1) + "/" + _vm._s(_vm.images.length) + " : " + _vm._s(image.name))]), _c('div', {
      staticClass: "images-div"
    }, [_c('span', {
      staticClass: "helper"
    }), _c('img', {
      attrs: {
        "src": image.content
      }
    })]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (image.annotation),
        expression: "image.annotation"
      }],
      ref: 'current',
      refInFor: true,
      staticClass: "center-block",
      attrs: {
        "placeholder": "Type a comment"
      },
      domProps: {
        "value": _vm._s(image.annotation)
      },
      on: {
        "keydown": [function($event) {
          if (_vm._k($event.keyCode, "enter", 13)) { return; }
          _vm.changeIndex(_vm.index + 1)
        }, function($event) {
          if (_vm._k($event.keyCode, "space", 32)) { return; }
          if (!$event.ctrlKey) { return; }
          _vm.changeIndex(_vm.index - 1)
        }],
        "input": function($event) {
          if ($event.target.composing) { return; }
          image.annotation = $event.target.value
        }
      }
    }), _vm._m(0, true)]) : _vm._e()
  }), _c('div', {
    staticClass: "btn btn-default center-block",
    staticStyle: {
      "width": "150px"
    },
    on: {
      "click": _vm.getSummary
    }
  }, [_vm._v("Get summary")])], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infos"
  }, [_vm._v("Press "), _c('b', [_vm._v("Enter")]), _vm._v(" for the next picture, "), _c('b', [_vm._v("Ctrl+Space")]), _vm._v(" for the previous picture")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1b279850!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 17
// module chunks = 1